export * from './PropertiesMapper'
